import type { ReactNode } from 'react';
import { Badge } from '../../catalyst/badge';

type Props = {
  kind: string;
  /** The selection's buttons, right-aligned; the ones that do not fit wrap onto the next row, whole. */
  children?: ReactNode;
};

/** The top row of the selection panel: the node kind, and the actions on the selected node. */
export function SelectionHeader({ kind, children }: Props) {
  return (
    <div className="flex flex-wrap items-center justify-end *:whitespace-nowrap">
      <Badge color="zinc" className="mr-auto">
        {kind}
      </Badge>
      {children}
    </div>
  );
}
